import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './WaitlistModal.css';

const WaitlistModal = ({ show, onHide, isInvestorInquiry = false }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle email submission here
    console.log('Email submitted:', email);
    setEmail('');
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      className="waitlist-modal"
    >
      <Modal.Header closeButton className="waitlist-header">
      </Modal.Header>
      <Modal.Body className="waitlist-body">
        <div className="waitlist-content">
          <div className="my-5">
            <img src={process.env.PUBLIC_URL + '/blue_maia_navbar.svg'} alt="Maia Logo" className="img-fluid" />
          </div>
          <div className="my-5">
          {isInvestorInquiry ? (
            <h2 className="waitlist-title">Ready to learn more?</h2>
          ) : (
            <h2 className="waitlist-title">Join the Waitlist</h2>
          )}
          </div>
          
          {isInvestorInquiry ? (
            <p className="waitlist-description">
              Request access to our investor materials at <a href="mailto:investors@ask-maia.com">investors@ask-maia.com</a>.
            </p>
          ) : (
            <p className="waitlist-description">
              Be the first to know when MAIA launches. Join our waitlist to get early access and updates.
            </p>
          )}
          
          {!isInvestorInquiry && (
            <p className="waitlist-subtitle">
              Be the first to try <strong>MAIA.</strong>
            </p>
          )}
          
          <div className="d-flex justify-content-center">
            {!isInvestorInquiry && (
              <div className="klaviyo-form-Xkrk6z"></div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WaitlistModal;
